
import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DateRangePicker } from '@mui/x-date-pickers-pro';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import 'moment/locale/de';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomActionBar from './CustomActionBar';
import MobileWheelTimePicker from './MobileWheelTimePicker';
import WheelTimePicker from './WheelTimePicker';

// Nur Datumsansagen, aber mit Zeitauswahl
const DateRangeOnlyView = ({ startDate, setStartDate, setStartValue, endDate, setEndDate, setEndValue, shouldUpdate, setUpdated }) => {

    const theme = useTheme();
    const belowsm = useMediaQuery(theme.breakpoints.down("sm"));

    const [date, setDate] = useState([
        moment(),
        moment()
    ]);
    
    // const emtpyHoursAndMinutes = moment().set("hours", 0).set("minutes", 0).add(1, "days");
    const [close, setClose] = useState(false);

    const { t } = useTranslation();

    useEffect(() => {
        if (moment(endDate).isSame(moment(startDate), "day") && shouldUpdate) {
            const startDateAsMoment = moment(startDate);
            const endDateForDateRange = moment(startDate);
            endDateForDateRange.add(1, "day");
            endDateForDateRange.add(moment(endDate).diff(moment(startDate)));
            setDate([
                startDateAsMoment,
                endDateForDateRange
            ]);
            setEndDate(endDateForDateRange);
            setEndValue(endDateForDateRange);
        }
        setDate([
            startDate,
            endDate
        ])
        //eslint-disable-next-line
    }, [startDate, endDate])

    const setStartTime = (startTime) => {
        const newTime = moment(startTime);
        const newArr = [
            newTime,
            newTime.isAfter(date[1]) ? date[1].add(newTime.diff(date[0], "minute"), "minute") : date[1]
        ]
        setDate(newArr);
        setStartDate(newTime);
        setStartValue(newTime);
    };

    const setEndTime = (endTime) => {
        const newTime = moment(endTime);
        const newStartTime = moment(endTime);
        const isBefore = newTime.isBefore(date[0]);
        if (isBefore && newTime.format("HH:mm") !== "00:00") {
            newStartTime.subtract(15, "minute");
        }
        const newArr = [
            isBefore ? newStartTime : date[0],
            newTime
        ]
        setDate(newArr);
        if (isBefore) {
            setStartDate(newStartTime);
            setStartValue(newStartTime);
        }
        setEndDate(newTime)
        setEndValue(newTime);
    };

    const Seperator = () => {

        return (
            <Box
                sx={{ display: 'inline-block', transform: 'scale(1.2)', pl: 1.5, pt: 1 }}
            >
                _
            </Box>
        )
    };

    return (
        <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={localStorage.getItem("i18nextLng")}>
            <Grid
                item
                xs={3}
                sx={{
                    p: 1,
                    pb: belowsm ? 0 : 2,
                    ml: 1
                }}
            >
                <Grid container>
                    <Grid item xs={12}>
                        <DateRangePicker
                            localeText={{
                                start: t("startdate"),
                                end: t("enddate")
                            }}
                            format="DD.MM.YYYY"
                            value={date}
                            onChange={(newDate) => {
                                setDate((prevDate) => [
                                    newDate?.[0] ?? prevDate[0],
                                    newDate?.[1] ?? prevDate[1]
                                ]);
                            }}
                            onOpen={() => { setClose(true); }}
                            onClose={() => { setClose(false); }}
                            onAccept={(finalDate) => {
                                if (!finalDate || !finalDate[0]) {
                                    return;
                                }

                                const startTimeSource = date[0] ? moment(date[0]) : moment(startDate);
                                const endTimeSource = date[1] ? moment(date[1]) : moment(endDate);

                                const start = moment(finalDate[0]);
                                start.set("hour", startTimeSource.hour());
                                start.set("minute", startTimeSource.minute());
                                setStartDate(start);
                                setStartValue(start);
                                if (finalDate[1]) {
                                    const end = moment(finalDate[1]);
                                    end.set("hour", endTimeSource.hour());
                                    end.set("minute", endTimeSource.minute());
                                    setEndDate(end);
                                    setEndValue(end);
                                } else {
                                    const newEndDate = moment(finalDate[0]);
                                    newEndDate.set("hour", startTimeSource.hour());
                                    newEndDate.set("minute", startTimeSource.minute());
                                    newEndDate.add(1, "day");
                                    setDate([start, newEndDate]);
                                    setEndDate(newEndDate);
                                    setEndValue(newEndDate);
                                }
                                if (setUpdated) {
                                    setUpdated(true);
                                }
                            }}
                            slots={{
                                actionBar: CustomActionBar,
                            }}
                            slotProps={{
                                desktopPaper: {
                                    sx: {
                                        backgroundImage: "none"
                                    }
                                },
                                mobilePaper: {
                                    sx: {
                                        pt: 2,
                                        borderRadius: 6,
                                        backgroundImage: "none"
                                    }
                                },
                                textField: {
                                    InputLabelProps: {
                                        shrink: true
                                    }
                                },
                                toolbar: {
                                    hidden: true
                                }
                            }}
                        />
                    </Grid>
                </Grid>
            </Grid>
            <Grid
                item
                xs={3}
                sx={{
                    p: 1,
                    pt: belowsm ? 2 : 0,
                    ml: 1,
                }}
            >
                <Grid container>
                    <Grid item xs={5.5} sx={{ pr: .5 }}>
                        {
                            belowsm ?
                                <MobileWheelTimePicker label={t("time")} time={date[0]} setTime={setStartTime} setUpdated={setUpdated} /> :
                                <WheelTimePicker label={t("time")} value={date[0]} setValue={setStartTime} close={close} setUpdated={setUpdated} />
                        }
                    </Grid>
                    <Grid item xs={1} sx={{ visibility: "hidden" }}>
                        <Seperator />
                    </Grid>
                    <Grid item xs={5.5} sx={{ pl: .5 }}>
                        {
                            belowsm ?
                                <MobileWheelTimePicker label={t("time")} time={date[1]} setTime={setEndTime} setUpdated={setUpdated} /> :
                                <WheelTimePicker label={t("time")} value={date[1]} setValue={setEndTime} close={close} setUpdated={setUpdated} />
                        }
                    </Grid>
                </Grid>
            </Grid>
        </LocalizationProvider>
    );

};

export default DateRangeOnlyView;
